import { render, staticRenderFns } from "./approvalDokumen.vue?vue&type=template&id=763f7afa&scoped=true&"
import script from "./approvalDokumen.vue?vue&type=script&lang=js&"
export * from "./approvalDokumen.vue?vue&type=script&lang=js&"
import style0 from "./approvalDokumen.vue?vue&type=style&index=0&id=763f7afa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f7afa",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QSeparator,QImg,QBadge,QIcon,QChip,QBtn,QMenu,QList,QItem,QItemSection,QDialog,QSpace,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QSeparator,QImg,QBadge,QIcon,QChip,QBtn,QMenu,QList,QItem,QItemSection,QDialog,QSpace,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
